/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Text } from '@zapier/design-system';

import Number from 'app/developer-v3/components/Number';

const Styles = {
  root: css`
    display: flex;
    justify-content: space-between;
  `,
};

type Props = {
  label: string;
  value: number;
};

const CountItem = ({ label, value = 0 }: Props) => {
  return (
    <li css={Styles.root}>
      <Text fontWeight={400} tag="p" type="Title">
        {label}
      </Text>
      <Text fontWeight={600}>
        <Number>{value}</Number>
      </Text>
    </li>
  );
};

export default CountItem;
